import Link from "@/components/ui/Link";

export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon?: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  action?: { href: string; label: string };
}) {
  return (
    <div className="flex flex-col items-center px-4 py-20 text-center">
      {icon && <div className="glass mb-5 grid size-16 place-items-center rounded-full text-soft">{icon}</div>}
      <h2 className="text-[18px] text-fg">{title}</h2>
      {children && <p className="mt-2 max-w-md text-[14px] leading-relaxed text-muted">{children}</p>}
      {action && (
        <Link href={action.href} className="mt-6 inline-flex h-10 items-center rounded-full bg-white px-5 text-[14px] font-medium text-black hover:bg-white/85">
          {action.label}
        </Link>
      )}
    </div>
  );
}
